function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404Ship({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 350",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#33CC66"
    },
    points: "276.636,175.606 338.058,195.568 328.608,224.507  267.305,204.427  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#86E17A"
    },
    points: "276.636,175.606 338.058,195.568 335.105,204.545  273.801,184.465  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    points: "296.007,150.21 359.201,163.44 352.941,193.206  289.747,179.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFE45F"
    },
    points: "296.007,150.21 359.201,163.44 357.193,172.653  294.118,159.305  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#333333"
    },
    d: "M225.018,197.812l32.483,10.867 c1.299,0.473,2.835-0.945,3.544-3.071l38.507-115.639c0.709-2.126,0.236-4.252-1.063-4.607l-32.483-10.867 c-1.299-0.472-2.835,0.945-3.544,3.071l-38.507,115.757C223.246,195.332,223.718,197.458,225.018,197.812L225.018,197.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CCCCCC"
    },
    d: "M193.834,97.293l98.984,33.073l-31.538,94.732L129.341,181.04 c-4.489-1.536-5.434-6.379-2.008-10.867l52.091-67.564C182.731,98.119,189.346,95.757,193.834,97.293L193.834,97.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E4E4E4"
    },
    d: "M193.834,97.293l30.12,10.04l-31.42,94.732l-63.194-21.025 c-4.489-1.536-5.434-6.379-2.008-10.867l52.091-67.564C182.731,98.119,189.346,95.757,193.834,97.293L193.834,97.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666666"
    },
    d: "M417.316,253.683c-34.963,52.799-118.12,73.47-200.213,46.067 C123.317,268.33,66.147,186.119,89.416,116.074l31.065,10.276c1.654,16.064,14.411,32.955,28.349,37.68l98.157,32.719l1.063,0.472 L417.316,253.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    d: "M143.043,258.88c-47.012-39.216-69.809-94.023-53.626-142.806 l31.065,10.276c1.654,16.064,14.411,32.955,28.349,37.68l23.151,7.678L143.043,258.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF272C"
    },
    d: "M401.843,272.11c-40.397,38.743-112.922,51.618-184.739,27.64 l0,0l0,0C145.169,275.771,94.85,221.791,85.755,166.393l151.784,50.791l2.244,0.709L401.843,272.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF3D41"
    },
    d: "M143.043,258.88c-31.184-26.104-51.736-58.942-57.288-92.488 l79.258,26.577L143.043,258.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#333333"
    },
    d: "M392.866,279.787 c-41.578,32.719-109.024,42.287-175.762,19.962c-66.856-22.325-115.048-70.517-128.868-121.663l147.059,49.138l1.89,0.591 L392.866,279.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#474747"
    },
    d: "M143.043,258.88c-27.64-23.033-46.893-51.5-54.807-80.794 l73.589,24.569L143.043,258.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M106.426,139.343c4.016,1.299,6.26,5.788,4.843,9.804 c-1.299,4.016-5.67,6.26-9.804,4.961c-4.016-1.417-6.26-5.788-4.843-9.922C97.921,140.17,102.291,137.926,106.426,139.343 L106.426,139.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M260.572,139.934l-12.403-4.134 c-2.48-0.827-5.315,0.591-6.142,3.071l-3.544,10.749c-0.827,2.599,0.591,5.315,3.071,6.142l12.403,4.134 c2.48,0.827,5.197-0.591,6.024-3.071l3.544-10.749C264.47,143.596,263.052,140.761,260.572,139.934L260.572,139.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M159.579,128.358l13.466-17.6l58.115,19.372 c2.48,0.827,3.898,3.662,3.071,6.142l-3.662,10.749c-0.827,2.48-3.544,3.898-6.024,3.071L159.579,128.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M286.676,148.675l-9.45-3.189 c-2.48-0.827-5.315,0.591-6.142,3.071l-3.544,10.867c-0.827,2.48,0.591,5.197,3.071,6.024l9.45,3.189L286.676,148.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF272C"
    },
    d: "M254.548,109.105l32.483,10.867 c1.181,0.354,2.362,0.236,2.599-0.354l10.749-32.483c0.236-0.591-0.591-1.417-1.89-1.772l-32.483-10.867 c-1.299-0.472-2.48-0.354-2.599,0.236l-10.867,32.483C252.421,107.805,253.248,108.632,254.548,109.105L254.548,109.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666666"
    },
    d: "M258.918,95.875l32.483,10.749 c1.299,0.473,2.362,0.473,2.48,0.118l6.733-19.962c0.118-0.354-0.827-1.063-2.126-1.417l-32.483-10.867 c-1.299-0.472-2.362-0.472-2.48-0.118L256.91,94.34C256.674,94.812,257.619,95.403,258.918,95.875L258.918,95.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF8331"
    },
    d: "M385.188,184.229c9.213,0,16.773,7.56,16.773,16.891 c0,9.331-7.56,16.891-16.773,16.891c-9.331,0-16.891-7.56-16.891-16.891C368.297,191.788,375.856,184.229,385.188,184.229 L385.188,184.229z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.534,
    y: 183.284,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFF6A"
    },
    width: 3.189,
    height: 36.027
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.234,
    y: 199.702,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFF6A"
    },
    width: 35.79,
    height: 3.189
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M385.188,194.269c3.78,0,6.851,3.071,6.851,6.851 s-3.071,6.851-6.851,6.851c-3.78,0-6.851-3.071-6.851-6.851S381.408,194.269,385.188,194.269L385.188,194.269z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M89.535,239.509c0,3.071,3.78,5.552,8.505,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.386-5.67c4.725,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.505-5.67c4.607,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.387,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.505-5.67c4.725,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 c4.607,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.387-5.67c4.725,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.505-5.67c4.607,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.386,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.505-5.67c4.725,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 c4.607,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.387-5.67c4.725,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.505-5.67c4.607,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.386,5.552 c4.725,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.505-5.67s8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 c4.607,0,8.505-2.48,8.505-5.552c0-3.189,3.78-5.67,8.386-5.67c4.725,0,8.505,2.48,8.505,5.67c0,3.071,3.78,5.552,8.505,5.552 v2.362h31.066v147.886h-31.066v13.584H64.139v-13.584H34.963V247.423h29.175v-2.362c4.607,0,8.386-2.48,8.386-5.552 c0-3.189,3.78-5.67,8.505-5.67C85.755,233.839,89.535,236.319,89.535,239.509L89.535,239.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M92.015,239.509c0,0.709,0.473,1.299,1.299,1.89 c1.181,0.827,2.835,1.299,4.725,1.299s3.425-0.473,4.607-1.299c0.827-0.591,1.417-1.181,1.417-1.89 c0-2.48,1.417-4.607,3.544-6.024c2.008-1.299,4.607-2.126,7.323-2.126c2.835,0,5.434,0.827,7.442,2.126 c2.126,1.417,3.544,3.544,3.544,6.024c0,0.709,0.591,1.299,1.418,1.89c1.181,0.827,2.717,1.299,4.607,1.299 c1.89,0,3.544-0.473,4.725-1.299c0.827-0.591,1.299-1.181,1.299-1.89c0-2.48,1.417-4.607,3.662-6.024 c1.89-1.299,4.489-2.126,7.323-2.126c2.835,0,5.433,0.827,7.323,2.126c2.244,1.417,3.544,3.544,3.544,6.024 c0,0.709,0.591,1.299,1.417,1.89c1.181,0.827,2.835,1.299,4.607,1.299c1.89,0,3.544-0.473,4.725-1.299 c0.827-0.591,1.417-1.181,1.417-1.89c0-2.48,1.299-4.607,3.544-6.024c1.89-1.299,4.489-2.126,7.323-2.126 c2.835,0,5.433,0.827,7.323,2.126c2.244,1.417,3.662,3.544,3.662,6.024c0,0.709,0.472,1.299,1.299,1.89 c1.181,0.827,2.835,1.299,4.725,1.299c1.89,0,3.426-0.473,4.607-1.299c0.827-0.591,1.417-1.181,1.417-1.89 c0-2.48,1.417-4.607,3.544-6.024c2.008-1.299,4.607-2.126,7.324-2.126c2.835,0,5.433,0.827,7.441,2.126 c2.126,1.417,3.544,3.544,3.544,6.024c0,0.709,0.472,1.299,1.417,1.89c1.181,0.827,2.717,1.299,4.607,1.299 c1.89,0,3.544-0.473,4.725-1.299c0.827-0.591,1.299-1.181,1.299-1.89c0-2.48,1.417-4.607,3.662-6.024 c1.89-1.299,4.488-2.126,7.323-2.126c2.835,0,5.434,0.827,7.323,2.126c2.244,1.417,3.544,3.544,3.544,6.024 c0,0.709,0.591,1.299,1.417,1.89c1.181,0.827,2.835,1.299,4.607,1.299c1.89,0,3.544-0.473,4.725-1.299 c0.827-0.591,1.417-1.181,1.417-1.89c0-2.48,1.299-4.607,3.544-6.024c1.89-1.299,4.488-2.126,7.323-2.126s5.434,0.827,7.323,2.126 c2.244,1.417,3.662,3.544,3.662,6.024c0,0.709,0.473,1.299,1.299,1.89c1.181,0.827,2.835,1.299,4.725,1.299 c1.89,0,3.426-0.473,4.607-1.299c0.827-0.591,1.418-1.181,1.418-1.89c0-2.48,1.417-4.607,3.544-6.024 c2.008-1.299,4.607-2.126,7.323-2.126c2.835,0,5.434,0.827,7.441,2.126c2.126,1.417,3.544,3.544,3.544,6.024 c0,0.709,0.473,1.299,1.417,1.89c1.063,0.827,2.717,1.299,4.607,1.299c1.89,0,3.544-0.473,4.725-1.299 c0.827-0.591,1.299-1.181,1.299-1.89c0-2.48,1.417-4.607,3.662-6.024c1.89-1.299,4.489-2.126,7.323-2.126 c2.835,0,5.434,0.827,7.323,2.126c2.244,1.417,3.544,3.544,3.544,6.024c0,0.709,0.591,1.299,1.417,1.89 c1.181,0.827,2.835,1.299,4.607,1.299c1.89,0,3.544-0.473,4.725-1.299c0.827-0.591,1.417-1.181,1.417-1.89 c0-2.48,1.299-4.607,3.544-6.024c1.89-1.299,4.488-2.126,7.323-2.126s5.434,0.827,7.323,2.126 c2.244,1.417,3.662,3.544,3.662,6.024c0,0.709,0.472,1.299,1.299,1.89c1.181,0.827,2.835,1.299,4.725,1.299 c1.89,0,3.426-0.473,4.607-1.299c0.827-0.591,1.417-1.181,1.417-1.89c0-2.48,1.418-4.607,3.544-6.024 c1.89-1.299,4.607-2.126,7.323-2.126c2.835,0,5.434,0.827,7.442,2.126c2.126,1.417,3.544,3.544,3.544,6.024 c0,0.709,0.472,1.299,1.417,1.89c1.063,0.827,2.717,1.299,4.607,1.299h2.48v2.362v2.362h-4.961 c-1.772-0.354-3.543-1.063-4.843-1.89c-2.244-1.536-3.544-3.662-3.544-6.024c0-0.709-0.591-1.417-1.417-2.008 c-1.181-0.709-2.835-1.181-4.725-1.181c-1.772,0-3.425,0.473-4.607,1.181c-0.827,0.591-1.418,1.299-1.418,2.008 c0,2.362-1.299,4.489-3.544,6.024c-1.299,0.827-3.071,1.536-4.961,1.89h-4.843c-1.89-0.354-3.544-1.063-4.843-1.89 c-2.244-1.536-3.662-3.662-3.662-6.024c0-0.709-0.473-1.417-1.299-2.008c-1.181-0.709-2.835-1.181-4.725-1.181 c-1.89,0-3.544,0.473-4.607,1.181c-0.945,0.591-1.417,1.299-1.417,2.008c0,2.362-1.417,4.489-3.544,6.024 c-1.417,0.827-3.071,1.536-4.961,1.89h-4.843c-1.89-0.354-3.544-1.063-4.961-1.89c-2.126-1.536-3.544-3.662-3.544-6.024 c0-0.709-0.591-1.417-1.417-2.008c-1.181-0.709-2.717-1.181-4.607-1.181s-3.544,0.473-4.725,1.181 c-0.827,0.591-1.299,1.299-1.299,2.008c0,2.362-1.417,4.489-3.662,6.024c-1.299,0.827-2.953,1.536-4.843,1.89h-4.961 c-1.772-0.354-3.544-1.063-4.843-1.89c-2.244-1.536-3.544-3.662-3.544-6.024c0-0.709-0.591-1.417-1.417-2.008 c-1.181-0.709-2.835-1.181-4.725-1.181c-1.772,0-3.426,0.473-4.607,1.181c-0.827,0.591-1.417,1.299-1.417,2.008 c0,2.362-1.299,4.489-3.544,6.024c-1.299,0.827-3.071,1.536-4.961,1.89h-4.843c-1.89-0.354-3.544-1.063-4.843-1.89 c-2.244-1.536-3.662-3.662-3.662-6.024c0-0.709-0.473-1.417-1.299-2.008c-1.181-0.709-2.835-1.181-4.725-1.181 c-1.89,0-3.544,0.473-4.607,1.181c-0.945,0.591-1.417,1.299-1.417,2.008c0,2.362-1.418,4.489-3.544,6.024 c-1.417,0.827-3.071,1.536-4.961,1.89h-4.843c-1.89-0.354-3.544-1.063-4.961-1.89c-2.126-1.536-3.544-3.662-3.544-6.024 c0-0.709-0.591-1.417-1.418-2.008c-1.181-0.709-2.717-1.181-4.607-1.181c-1.89,0-3.544,0.473-4.725,1.181 c-0.827,0.591-1.299,1.299-1.299,2.008c0,2.362-1.417,4.489-3.662,6.024c-1.299,0.827-2.953,1.536-4.843,1.89h-4.961 c-1.772-0.354-3.544-1.063-4.843-1.89c-2.244-1.536-3.544-3.662-3.544-6.024c0-0.709-0.591-1.417-1.417-2.008 c-1.181-0.709-2.835-1.181-4.725-1.181c-1.772,0-3.425,0.473-4.607,1.181c-0.827,0.591-1.417,1.299-1.417,2.008 c0,2.362-1.299,4.489-3.544,6.024c-1.299,0.827-3.071,1.536-4.843,1.89h-4.961c-1.89-0.354-3.543-1.063-4.843-1.89 c-2.244-1.536-3.662-3.662-3.662-6.024c0-0.709-0.472-1.417-1.299-2.008c-1.181-0.709-2.835-1.181-4.725-1.181 c-1.89,0-3.425,0.473-4.607,1.181c-0.945,0.591-1.417,1.299-1.417,2.008c0,2.362-1.417,4.489-3.544,6.024 c-1.417,0.827-3.071,1.536-4.961,1.89h-4.843c-1.89-0.354-3.543-1.063-4.961-1.89c-2.126-1.536-3.544-3.662-3.544-6.024 c0-0.709-0.591-1.417-1.417-2.008c-1.181-0.709-2.717-1.181-4.607-1.181c-1.89,0-3.544,0.473-4.725,1.181 c-0.827,0.591-1.299,1.299-1.299,2.008c0,2.362-1.417,4.489-3.662,6.024c-1.299,0.827-2.953,1.536-4.843,1.89h-4.961 c-1.772-0.354-3.544-1.063-4.843-1.89c-2.244-1.536-3.544-3.662-3.544-6.024c0-0.709-0.591-1.417-1.417-2.008 c-1.181-0.709-2.835-1.181-4.725-1.181c-1.772,0-3.425,0.473-4.607,1.181c-0.827,0.591-1.417,1.299-1.417,2.008 c0,2.362-1.299,4.489-3.544,6.024c-1.299,0.827-3.071,1.536-4.843,1.89h-4.961c-1.89-0.354-3.544-1.063-4.843-1.89 c-2.244-1.536-3.662-3.662-3.662-6.024c0-0.709-0.472-1.417-1.299-2.008c-1.181-0.709-2.835-1.181-4.725-1.181 c-1.89,0-3.426,0.473-4.607,1.181c-0.827,0.591-1.417,1.299-1.417,2.008c0,2.362-1.417,4.489-3.544,6.024 c-1.417,0.827-3.071,1.536-4.961,1.89h-4.843v-2.362v-2.362h2.48c1.772,0,3.425-0.473,4.607-1.299 c0.827-0.591,1.417-1.181,1.417-1.89c0-2.48,1.299-4.607,3.544-6.024c1.89-1.299,4.488-2.126,7.323-2.126 c2.835,0,5.433,0.827,7.323,2.126C90.598,234.902,92.015,237.028,92.015,239.509L92.015,239.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M62.958,242.698H25.632c-1.299,0-2.362,1.063-2.362,2.362l0,0 c0,1.299,1.063,2.362,2.362,2.362h37.326c1.181,0,2.244-1.063,2.244-2.362l0,0C65.202,243.761,64.139,242.698,62.958,242.698 L62.958,242.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M475.785,242.698h-37.208c-1.299,0-2.362,1.063-2.362,2.362 l0,0c0,1.299,1.063,2.362,2.362,2.362h37.208c1.299,0,2.362-1.063,2.362-2.362l0,0 C478.148,243.761,477.085,242.698,475.785,242.698L475.785,242.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M442.003,271.991h-16.301c-1.299,0-2.362,1.063-2.362,2.362 l0,0c0,1.299,1.063,2.244,2.362,2.244h16.301c1.299,0,2.362-0.945,2.362-2.244l0,0 C444.366,273.055,443.303,271.991,442.003,271.991L442.003,271.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M360.028,271.991H287.03c-1.181,0-2.244,1.063-2.244,2.362 l0,0c0,1.299,1.063,2.244,2.244,2.244h72.998c1.299,0,2.362-0.945,2.362-2.244l0,0 C362.391,273.055,361.328,271.991,360.028,271.991L360.028,271.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M258.445,271.991h-34.136c-1.299,0-2.362,1.063-2.362,2.362 l0,0c0,1.299,1.063,2.244,2.362,2.244h34.136c1.299,0,2.362-0.945,2.362-2.244l0,0 C260.808,273.055,259.745,271.991,258.445,271.991L258.445,271.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M105.953,271.991h-3.78c-1.299,0-2.362,1.063-2.362,2.362l0,0 c0,1.299,1.063,2.244,2.362,2.244h3.78c1.299,0,2.362-0.945,2.362-2.244l0,0C108.316,273.055,107.252,271.991,105.953,271.991 L105.953,271.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M136.782,287.229h-14.765c-1.299,0-2.362,1.063-2.362,2.362 l0,0c0,1.299,1.063,2.362,2.362,2.362h14.765c1.299,0,2.362-1.063,2.362-2.362l0,0 C139.145,288.292,138.082,287.229,136.782,287.229L136.782,287.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M458.776,294.08h-3.071c-1.299,0-2.362,1.063-2.362,2.362l0,0 c0,1.299,1.063,2.362,2.362,2.362h3.071c1.181,0,2.244-1.063,2.244-2.362l0,0C461.021,295.143,459.957,294.08,458.776,294.08 L458.776,294.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M302.032,299.159h-34.137c-1.299,0-2.362,1.063-2.362,2.362 l0,0c0,1.299,1.063,2.362,2.362,2.362h34.137c1.299,0,2.362-1.063,2.362-2.362l0,0 C304.394,300.222,303.331,299.159,302.032,299.159L302.032,299.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3C0EF"
    },
    d: "M52.445,294.08h-3.071c-1.299,0-2.362,1.063-2.362,2.362l0,0 c0,1.299,1.063,2.362,2.362,2.362h3.071c1.181,0,2.244-1.063,2.244-2.362l0,0C54.689,295.143,53.626,294.08,52.445,294.08 L52.445,294.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404Ship);
export default __webpack_public_path__ + "static/media/error-404-ship.9904324474827bc123f2378a985a79a0.svg";
export { ForwardRef as ReactComponent };